import { CalculatorService } from '../services/CalculatorService';
import { OrderService } from '../services/OrderService';
import { createOrder, buildBoxes, normalizePhone } from '../mappers/orderMappers';
import { isAfterCutoff22, isFakeAcceptanceDate } from '../utils/dateUtils';
import { PriceRequest } from '../models/PriceRequest';
import { BoxInput } from '../types/form';

type SubmitCtx = {
    priceReq: PriceRequest;
    boxesInputs: BoxInput[];
    pallet: boolean;
    supplyMeta: {
        entity: string;
        departureDate: Date;
        acceptanceDate: Date;
        phoneMasked: string;
        sendCity: string;
        store: string;
        supplyType: string;
        willTaken: boolean;
        payment: boolean;
        comment: string;
        ozonNumber: string;
        supplyId: number;
        paymentStatus?: boolean;
        changeable?: boolean;
        status?: string;
        baseOrder?: any;
    };
    now?: Date;
};

export const useOrderSubmission = () => {
    const calculator = new CalculatorService();
    const orders = new OrderService();

    const submit = async (ctx: SubmitCtx) => {
        if (isAfterCutoff22(ctx.supplyMeta.acceptanceDate, ctx.now) && !ctx.supplyMeta.baseOrder) {
            const err: any = new Error('AFTER_CUTOFF');
            err.code = 'AFTER_CUTOFF';
            throw err;
        }

        const boxes = buildBoxes(ctx.boxesInputs);
        const { price, volume } = await calculator.calculate(ctx.priceReq, ctx.pallet ? boxes : undefined);

        let acceptance = ctx.supplyMeta.acceptanceDate;
        if (isFakeAcceptanceDate(acceptance)) acceptance = new Date(ctx.supplyMeta.departureDate);

        const order = createOrder({
            ...ctx.supplyMeta,
            acceptanceDate: acceptance,
            volume,
            price,
            phone: normalizePhone(ctx.supplyMeta.phoneMasked),
            base: ctx.supplyMeta.baseOrder,
        });

        const created = await orders.create(order, boxes);
        return { created, price, volume };
    };

    return { submit };
};
